import { useMutation } from "@apollo/client";
import {
  Box,
  CircularProgress,
  Divider,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import { React, useEffect, useState } from "react";
import { FETCH_LOG } from "../../../../../graphql/mutation/mutation";
import { appUrl, formatDate } from "../../../../../utils/Utils";
import ApiTableComponent from "../../../../base/ApiTable.component";

const ApiResponseDialog = ({ userId }) => {
  const [fetchPayload, { data: payloadData }] = useMutation(FETCH_LOG);

  useEffect(() => {
    fetchPayload({
      variables: {
        userId: userId,
      },
    });
  }, [userId, fetchPayload]);

  const [payload, setPayload] = useState([]);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (payloadData?.fetchApiLog?.payload?.length > 0) {
      for (const data of payloadData.fetchApiLog.payload) {
        let output = JSON.parse(data.output_payload);

        if (output)
          setPayload((prev) => [
            ...prev,
            {
              ...output.pull,
              public_url: `${appUrl}/verification/consent`,
              created_at: data.created_at,
            },
          ]);
      }
    }
  }, [payloadData]);

  const savePayload = (data) => {
    setResponse(data);
  };

  return (
    <>
      <Divider />
      {payload.length > 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <FormControl sx={{ m: 1 }}>
              <Select
                value={response ? response.created_at : payload[0].created_at}
                inputProps={{ "aria-label": "Without label" }}
                size="small"
                style={{ fontSize: "14px", width: "200px" }}
                // label={"Select date"}
              >
                {payload.map((data, index) => (
                  <MenuItem
                    key={index}
                    value={data.created_at}
                    onClick={() => savePayload(data)}
                  >
                    {formatDate(data.created_at)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <ApiTableComponent payload={response || payload[0]} />
        </Box>
      ) : (
        <div
          style={{
            display: "flex",
            height: "66vh",
            justifyContent: "center",
            margin: "24px",
          }}
        >
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default ApiResponseDialog;
